<template>
  <elements-layout
          :extra-filters="extraFilters"
          :table-columns='tableColumns'
          :fetch-data-url='fetchDataUrl'

          :tableRepresentation="true"

          :store-module-name="STORE_MODULE_NAME"
          :store-module-config="STORE_MODULE_CONFIG"

          :addDataSidebarAvailable="$can('create', 'station')"

  >

    <template #addDataForm>
      <station-add-update></station-add-update>
    </template>

    <template #tableCellCustomRepresentations="cell">

        <template v-if="cell.field.key === 'station'">
            <template v-if="get(cell.item, 'id')">
                <station-cell :data="cell.item"></station-cell>
            </template>
            <template v-else>
                {{cell.item}}
            </template>
        </template>
        <template v-else-if="cell.field.key === 'railway_sector'">
            <template v-if="get(cell.value, 'id')">
                <station-cell :data="cell.value"></station-cell>
            </template>

        </template>
        <template v-else-if="cell.field.key === 'user'">
            <template v-if="get(cell.value, 'id')">
                <user-cell :user="cell.value"></user-cell>
            </template>

        </template>
    </template>

  </elements-layout>
</template>

<script>

  import ElementsLayout from '@core/components/app-elements/AppElementsLayout.vue'

  import {STORE_MODULE_NAME, STORE_MODULE_CONFIG} from '../stationStoreModule'
  import useStation from '../useStation'

  import StationAddUpdate from '../components/StationAddUpdate'

  import get from 'lodash.get'

  import UserCell from "@/views/apps/user/components/UserCell";

  import StationCell from "@/views/apps/railway_structure/station/components/StationCell";
  import SectorCell from "@/views/apps/railway_structure/sector/components/SectorCell";
  import RailwayCell from "@/views/apps/railway_structure/railway/components/RailwayCell";

  export default {
    props: {
      // Фильтр приходит из карточки родителя: список внутри вкладки обязан
      // показывать только подчинённые записи, а не всё подряд
      extraFilters: {
        type: Object,
        default: () => ({}),
        required: false,
      },
    },
    components: {
        RailwayCell,
        UserCell,
        SectorCell,
      StationCell,
      ElementsLayout,
      StationAddUpdate,
    },
    setup() {

      const {

        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

      } = useStation();

      return {
        fetchDataUrl,
        deleteDataUrl,
        tableColumns,

        STORE_MODULE_NAME,
        STORE_MODULE_CONFIG,

        get,
      }
    },
  }
</script>
